import { createFileRoute, redirect } from '@tanstack/react-router';

// Settings sections are mounted inline from `/settings?tab=<id>` (see settings.tsx),
// while the section list names each one `/settings/<id>`. Sections owning a route of
// their own keep it — a static path always outranks this dynamic one, so their bounces
// and drill-ins are untouched. Everything else, including any section added later and an
// unknown path below one (`/settings/bogus/deeper`), lands here and is forwarded to the
// `?tab=` form, so a typed or bookmarked deep-link opens the section instead of falling
// through to Not Found. An unknown id is safe: the page falls back to the first section
// the viewer can see. The router forces `replace` on a redirect thrown during load, so
// Back leaves Settings rather than returning here.
export const Route = createFileRoute('/settings/$section')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/settings', search: { tab: params.section.toLowerCase() } });
  },
});
